import { MessageTypeInterface } from "../interfaces/MessageType.interface";

// eslint-disable-next-line import/prefer-default-export
export const BLANK_MESSAGE_TYPE: MessageTypeInterface = {
  id: 9999,
  name: "ALL",
  color: "gray",
  messages: [],
  active: true,
};
